<div class="w-100 h-100 form">
  <h4 class="text-center">{{this.linkInfo.id == 0 ? 'Nuevo' : 'Editar' }} Menú</h4>
  <div class="row mx-0 mt-3 p-0 w-100">
    <div class="col-6 col-xl-3">
      <div class="">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título de Menú</mat-label>
          <input matInput placeholder="Título de Menú" [(ngModel)]="this.linkInfo.value" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6 col-xl-3">
      <div class="">
        <!-- <h5 class="m-0 font-weight-bold">Url de Menú</h5> -->
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Url de Menú</mat-label>
          <input autocomplete="off" matInput placeholder="Url de Menú" [(ngModel)]="this.linkInfo.url" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <!--    <div class="col-3">-->
    <!--      <div class="mb-3">-->
    <!--        <div>-->
    <!--          <h5 class="m-0 font-weight-bold">Sera este un link externo?</h5>-->
    <!--        </div>-->
    <!--        <mat-button-toggle-group [(ngModel)]="this.linkInfo.urlExterno" [value]="linkInfo.urlExterno"-->
    <!--                                 aria-label="img activo">-->
    <!--          <mat-button-toggle [value]="true">-->
    <!--            <mat-icon style="color: green">check</mat-icon>-->
    <!--          </mat-button-toggle>-->
    <!--          <mat-button-toggle [value]="false">-->
    <!--            <mat-icon style="color: red">cancel</mat-icon>-->
    <!--          </mat-button-toggle>-->
    <!--        </mat-button-toggle-group>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="col-6 col-xl-3">
      <div class="">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Ubicación</mat-label>
          <mat-select class="selectOption" [(value)]="this.linkInfo.type" required>
            <mat-option [value]=2> Menú Superior (Nosotros...) </mat-option>
            <mat-option [value]=1> Menú (Inicio...) </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6 col-xl-3">
      <div class="">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Orden</mat-label>
          <input type="number" matInput placeholder="1, 2, 3" [(ngModel)]="this.linkInfo.order" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="row mx-0 p-0 w-100">
    <div class="col-6 col-xl-3">
      <div class="mb-3">
        <div>
          <h5 class="m-0 font-weight-bold">¿Este menú tendrá ícono?</h5>
        </div>
        <mat-button-toggle-group [(ngModel)]="hasImg" [value]="hasImg" aria-label="img activo">
          <mat-button-toggle [value]="true">
            <mat-icon style="color: green">check</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle [value]="false">
            <mat-icon style="color: red">cancel</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>

        <!--
        <div class="mb-3" *ngIf="linkInfo.imgActivo">
          <mat-label>Nombre de icono</mat-label>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="Nombre de Icono" [(ngModel)]="this.linkInfo.img">
                      <mat-error>Este campo es <b>Requerido</b></mat-error>
            <mat-hint>Escribe nombres de iconos de angular material <br>
              <a target="_blank"
                 href="https://fonts.google.com/icons?selected=Material+Icons"> Más
                Información</a></mat-hint>
          </mat-form-field>
        </div> -->
      </div>
    </div>

    <div class="col-6 col-xl-3 vs-outline-editCard h-fit-content" *ngIf="hasImg">
      <img class="given-img menu-img" [src]="srcData | safeDom" alt="img-benefit-slide" *ngIf="fileImg64">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload" class="custom-file-upload mt-5">
          <mat-icon>{{!fileImg64 ? 'image': '' }} </mat-icon>
          <span class="my-2 text-center">Elegir imagen</span>
        </label>
        <input id="file-upload" type="file" accept="image/*" (change)="getBase64($event)" required />
      </div>
    </div>

    <div class="col-12 d-flex align-items-center">
      <button mat-flat-button aria-label="Add Link" class="save-button" (click)="createLinkFields()">
        Agregar un submenú +
      </button>
    </div>
    <div class="col-12">
      <div class=" max-height">
        <div *ngFor="let link of this.linkInfo.items, index as i">
          <div class="d-flex align-items-center">
            <h5 class="m-0 font-weight-bold">Menú {{i + 1}}</h5>
          </div>
          <div class="row ">
            <div class="col-3">
              <mat-form-field appearance="outline" class=" w-100 me-4">
                <mat-label>Título de Menú</mat-label>
                <input matInput placeholder="Título de Link" [(ngModel)]="link.value" required>
                <mat-error>Este campo es <b>Requerido</b></mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field appearance="outline" class=" w-100">
                <mat-label>Url de Menú</mat-label>
                <input autocomplete="off" matInput placeholder="URL de Link" [(ngModel)]="link.url" required>
                <mat-error>Este campo es <b>Requerido</b></mat-error>
              </mat-form-field>
            </div>
            <!--            <div class="col-2">-->
            <!--              <div class="mb-3">-->
            <!--                <div>-->
            <!--                  <h5 class="m-0 font-weight-bold">Sera un link externo?</h5>-->
            <!--                </div>-->
            <!--                <mat-button-toggle-group [(ngModel)]="link.urlExterno" [value]="link.urlExterno"-->
            <!--                                         aria-label="img activo">-->
            <!--                  <mat-button-toggle [value]="true">Si</mat-button-toggle>-->
            <!--                  <mat-button-toggle [value]="false">No</mat-button-toggle>-->
            <!--                </mat-button-toggle-group>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="col-3">
              <div class="">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Orden</mat-label>
                  <input matInput placeholder="1" [(ngModel)]="link.order" required>
                  <mat-error>Este campo es <b>Requerido</b></mat-error>
                </mat-form-field>
              </div>
              <!-- <div class="mb-3">
                <div>
                  <h5 class="m-0 font-weight-bold">Este link tendra icono?</h5>
                </div>
                <mat-button-toggle-group [(ngModel)]="link.imgActivo" [value]="link.imgActivo" aria-label="img activo">
                  <mat-button-toggle [value]="true">Si</mat-button-toggle>
                  <mat-button-toggle [value]="false" (click)="link.img = ''">No</mat-button-toggle>
                </mat-button-toggle-group>

                <div class="mb-3" *ngIf="link.imgActivo">
                  <mat-label>Nombre de icono</mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput placeholder="Nombre de Icono" [(ngModel)]="link.img">
                              <mat-error>Este campo es <b>Requerido</b></mat-error>
                    <mat-hint>Escribe nombres de iconos de angular material <br>
                      <a target="_blank"
                        href="https://www.angularjswiki.com/angular/angular-material-icons-list-mat-icon-list/"> Más
                        Información</a>
                    </mat-hint>
                  </mat-form-field>
                </div>
              </div> -->
            </div>
            <div class="col mt-2">
              <button mat-icon-button (click)="deleteLinkField(i)">
                <mat-icon color="warn">delete</mat-icon>
              </button>
              <button mat-icon-button (click)="createSubLinkFields(i)">
                <mat-icon color="primary">move_down</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="link.detail?.length > 0" class="border-subItems">
            <div *ngFor="let subLink of link.detail, index as subI">
              <div class="d-flex align-items-center">
                <h5 class="m-0 font-weight-bold">SubMenú {{subI + 1}}</h5>
              </div>
              <div class="row ">
                <div class="col-3">
                  <mat-form-field appearance="outline" class=" w-100 me-4">
                    <mat-label>Título de SubMenú</mat-label>
                    <input matInput placeholder="Título de Link" [(ngModel)]="subLink.value" required>
                    <mat-error>Este campo es <b>Requerido</b></mat-error>
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field appearance="outline" class=" w-100">
                    <mat-label>Url de SubMenú</mat-label>
                    <input autocomplete="off" matInput placeholder="URL de Link" [(ngModel)]="subLink.url" required>
                    <mat-error>Este campo es <b>Requerido</b></mat-error>
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <div class="">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Orden</mat-label>
                      <input matInput placeholder="1" [(ngModel)]="subLink.order" required>
                      <mat-error>Este campo es <b>Requerido</b></mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col mt-2">
                  <button mat-icon-button (click)="deleteSubLinkField(i, subI)">
                    <mat-icon color="warn">delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mx-3 d-flex justify-content-center">
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" (click)="sendData()" [disabled]="!validateEmptyFields()">
      Guardar
    </button>
  </div>
</div>